export class LoginShared {
  email?: string;
  mfaProviders?: string[];
  mfaCode?: string;
}
